import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const SoePage = lazy(() => import('src/pages/pms/soe-exact/list'));
const CompassEditPage = lazy(() => import('src/pages/compass/edit'));
const SoeAddPage = lazy(() => import('src/pages/pms/soe-exact/add'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const pmsRoutes = [
  {
    path: 'pms/soe-excact',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <SoePage />, index: true },
      { path: 'list', element: <SoePage /> },
      { path: 'create', element: <SoeAddPage /> },
    ],
  },
];
